/**
 * Donator Client Configuration
 * Overrides default configuration for Donator client
 */

import { defaultConfig } from './default';
import { PRICE_DISPLAY_MODES } from '../productPricing';

export const donatorConfig = {
  ...defaultConfig,

  // Client identification
  clientId: 'donator',
  clientName: 'Donator',

  // Currency settings - EUR for Donator
  currency: {
    code: 'EUR',
    symbol: '€',
    decimalPlaces: 2,
    thousandSeparator: '.',
    decimalSeparator: ',',
  },

  localization: {
    ...defaultConfig.localization,
    languages: ['sr-latn', 'sr', 'en'],
  },

  // Tax settings - 21% PDV for Donator
  tax: {
    pdv: 21,
    label: 'PDV',
  },

  productPricing: {
    ...defaultConfig.productPricing,
    defaultDisplayMode: PRICE_DISPLAY_MODES.RETAIL_WITH_PDV,
    strategy: 'price-inquiry',
    usePriceInquiry: true,
    retryPriceInquiry: true,
    inquiryTimeoutMs: 30000,
    showCartItemDiscountBreakdown: true,
    preserveTariffGroup: true,
    showRetailPriceTag: true,
    organizationOverrides: [
      {
        organizationIds: ['1396'],
        organizationNames: ['GRUPPO TESSILE'],
        displayMode: PRICE_DISPLAY_MODES.WHOLESALE_WITHOUT_PDV,
      },
    ],
  },

  productCatalog: {
    ...defaultConfig.productCatalog,
    quantityKeyboardPosition: 'bottom',
    highlightOrderRecency: true,
    filterOrder: [
      'supplier',
      ...defaultConfig.productCatalog.filterOrder.filter(
        (filter) => filter !== 'supplier',
      ),
    ],
    useUnrestrictedProductsQuery: true,
    includeSupplier: true,
    showQuantityFilter: false,
    showSupplierFilter: true,
    showDiscountFilter: false,
    showPdvToggle: false,
  },

  orders: {
    ...defaultConfig.orders,
    compactCartStorage: true,
    showDocumentTypeReport: true,
    useGrossCartPrices: true,
    refreshPricesBeforeDownload: true,
    showLocalBackupActions: true,
    showCartItemComments: true,
    showCartItemIdentifiers: true,
    showOrderAmountsInReport: true,
    // A Donator order cannot exceed the currently available stock of an item.
    limitQuantityToAvailableStock: true,
  },

  customers: {
    ...defaultConfig.customers,
    exitOnLogoClick: true,
    exitAfterCheckout: true,
    allowExitWithoutAdminOnIncompleteWork: true,
    showOpenItemsTab: false,
    openItemsMode: 'due-date',
  },

  tasks: {
    ...defaultConfig.tasks,
    allowStatusActionsWithoutSuperior: true,
  },

  sync: {
    ...defaultConfig.sync,
    defaultExcludedOptions: ['reports'],
    allowDeleteWithoutAdmin: true,
  },

  dayLifecycle: {
    ...defaultConfig.dayLifecycle,
    allowForceStartWithoutAdmin: true,
    compactFinishDayButton: true,
  },

  // Feature flags - Donator specific overrides
  features: {
    ...defaultConfig.features,
    fieldPhotos: true,
    showPaymentOption: false, // Hide payment option field for Donator
    showDeliveryDate: false, // Hide delivery date field for Donator
    showDiscount: false, // Hide discount (Diskont) checkbox for Donator
    showCustomerDebtInfo: true, // Show debt info on CustomerCard for Donator
    useCustomerDebtSnapshot: true, // Use RO_DUGOVANJA debt snapshot for Donator
    allowBlockedCustomerApproval: true, // Send blocked customer orders to approval flow
    showBlockedCustomerUnblockedSyncAlert: true, // Ask for sync if the customer was unblocked after opening the order
    refreshSelectedCustomerAfterSync: true, // Apply the unblocked state to the active customer without recreating the order
  },
};

export default donatorConfig;
